import axios from "axios";
const apiKey = process.env.REACT_APP_API;

const axiosInstance = axios.create({
  baseURL: apiKey,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authData");
    const bearerToken = token ? JSON.parse(token).token : null;
    config.headers["Authorization"] = `Bearer ${bearerToken}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    handleTokenErrors(error);
    return Promise.reject(error);
  }
);

export const handleTokenErrors = (error) => {
  if (error.response && error.response.status === 401) {
    localStorage.removeItem("authData");
    window.location.href = "/";
  }
};

export default axiosInstance;
